/*!
 * Copyright (c) Trimble Inc. All rights reserved
 */

import { Component } from '@angular/core';
import { GenericTableData } from 'src/app/sharedServices/generic-table-data.service';

@Component({
  selector: 'app-download',
  templateUrl: './download-content.component.html',
 })
export class DownloadContentComponent {

  constructor(
    public contentItemsManagementService: GenericTableData,
  ) {}

  pageTitle = 'Download Content';
  enabledDropdown = true;

  columnHeader = {
    checkbox: '',
    imageData: 'Image',
    name: 'Name',
    extendedName: 'Extended Name',
    manufacturer: 'Manufacturer',
    productLine: 'Productline',
    material: 'Material',
    productType: 'Product Type',
    relativeFileLocation: 'Relative File Location',
    specification: 'Specification',
    webServiceId: 'FittingEntryID'
  };
}
